<template>
  <home-page/>
</template>

<script>
import HomePage from '../components/HomePage/index'
export default {
  components: {HomePage  },

}
</script>

<style>

</style>
